var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticStyle:{"height":"50%","overflow-y":"scroll"}},[_c('server-table-component',{staticStyle:{"width":"100%"},attrs:{"table":"crm_sales_pipeline","schema":"sch_crm_sales_pipeline"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }